export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Hydrogen Technology Professional | London',
    'I finally understand the complete picture of hydrogen systems—from electrochemistry through production, fuel cells, storage, and industrial applications. This resource transformed how I approach hydrogen projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Renewable Energy Specialist | Dublin',
    'I know exactly how to explain hydrogen production, fuel cell technologies, storage infrastructure, and grid integration. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Energy Systems Engineer | Amsterdam',
    'The technical depth saves me countless hours. The integrated scenarios are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Hydrogen Professional',
    "Hydrogen production and fuel cell technologies completely changed how I understand energy conversion. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Energy Specialist',
    'The technical dictionary and misconceptions guide alone are worth the price. I never struggle with technical terminology or misunderstandings anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'Systems Engineer',
    'The 12 industry scenarios and hydrogen vs battery comparison were eye-opening. I can now explain hydrogen applications across renewable integration, refining, steelmaking, transportation, and power generation. This transformed my professional credibility.',
  ],
];
